<app-application-steps [showTechnicalFormFirst]="true" [currentStep]="step" [isDetailsView]="isDetailsView"></app-application-steps>

<div *ngIf="isLoading" class="loader-container">
  <div class="loader-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>
</div>

<div *ngIf="!isLoading" id="print-form">
  <app-documents-form
    #documentsForm
    [isLoading]="isLoading"
    [isDetailsView]="isDetailsView"
    [application_id]="application_id"
    [externalApplicationId]="externalApplicationId"
    [requiredDocuments]="requiredDocuments"
    [otherDocuments]="otherDocuments"
    [updateRequest]="updateRequest"
    [documentsSectionsState]="documentsSectionsState"
    [isLockUnlockButtonClicked]="isLockUnlockButtonClicked"
    [editabilityBasedOnProcessStatus]="editabilityBasedOnProcessStatus"
    [commentSectionOrderProcess$]="commentSectionOrderProcess$"
    [commentSectionEditableStatuses]="commentSectionEditableStatuses"
    [applicationTypeText]="applicationTypeName"
    (clearFile)="clearGridCompFile($event)"
    (updateComment)="updateGridCompComment($event)"
    (removeDocument)="removeGridCompDocument($event)"></app-documents-form>

  <app-grid-compatibility-assessment-result
    *ngIf="isDetailsView && !isModeratorRole()"
    [applicationId]="application_id"
    [isModerator]="false"
    (executedProcessAction)="executedProcessAction($event)"></app-grid-compatibility-assessment-result>

  <app-order-history *ngIf="isDetailsView" [applicationId]="application_id" [pagination]="true" class="order-history"></app-order-history>

  <div class="text-right-align top-margin send-message-section" *ngIf="isDetailsView">
    <button label="Download" pButton (click)="downloadAllDocuments()"></button>
    <button class="action-button" label="Print" pButton (click)="print()"></button>
  </div>

  <div class="add-more-prod" *ngIf="showAddMoreProductsButton && !isDetailsView">
    <i
      class="pi pi-shopping-cart add-more-prod-icon"
      [ngClass]="!operatorAgreementConfirmationIsInCompliance() || !requiredDocumentsFilled() ? 'add-more-prod-icon-disabled' : ''"
      pTooltip="{{ 'documents.add-more-prod' | translate }}"
      (click)="saveAndRedirectToProducts()"></i>
  </div>

  <div class="ui-g-12 submit-button-section">
    <button
      data-testId="btn-previous-page"
      *ngIf="isDetailsView"
      type="button"
      class="ui-button mr-3"
      (click)="previousPage()"
      label="{{ 'grid-comp.back' | translate | uppercase }}"
      pButton></button>

    <button
      data-testId="btn-save"
      *ngIf="isDetailsView"
      type="button"
      [disabled]="!(documentsForm?.documentsData?.dirty || isLockUnlockButtonClicked)"
      class="ui-button-save mr-3"
      (click)="saveFormData(false, false)"
      label="{{ 'grid-comp.save' | translate | uppercase }}"
      pButton></button>

    <button
      data-testId="btn-send-request"
      *ngIf="!isDetailsView"
      [disabled]="!operatorAgreementConfirmationIsInCompliance() || !requiredDocumentsFilled()"
      type="button"
      class="ui-button-proceed"
      (click)="saveFormData(true, false)"
      label="{{ 'grid-comp.send-request' | translate | uppercase }}"
      pButton></button>

    <button
      data-testId="btn-proceed"
      *ngIf="isDetailsView && isModeratorRole()"
      type="button"
      class="ui-button-proceed"
      (click)="saveFormData(true, false)"
      label="{{ 'grid-comp.proceed' | translate | uppercase }}"
      pButton></button>
  </div>
</div>
